export * from '@/store/modules/twitch/twitch.mutation'
export * from '@/store/modules/suggestions/suggestion.mutation'
export * from '@/store/modules/emotes/emote.mutation'
export * from '@/store/modules/notifications/notification.mutation'

export const UPDATE_USER = 'UPDATE_USER'

export const UPDATE_CHANNEL = 'UPDATE_CHANNEL'
export const UPDATE_LAST_SAVED_CHANNEL = 'UPDATE_LAST_SAVED_CHANNEL'
export const TOGGLE_LOADING_CHANNEL = 'TOGGLE_LOADING_CHANNEL'

export const UPDATE_MASTER_LIST = 'UPDATE_MASTER_LIST'

export const SET_FONT_LOADING_STATE = 'SET_FONT_LOADING_STATE'
export const SET_TITLE_FONT_LOADING_STATE = 'SET_TITLE_FONT_LOADING_STATE'
export const SET_HEADER_IMAGE_LOADING_STATE = 'SET_HEADER_IMAGE_LOADING_STATE'

export const SET_PLANNED_DOWNTIME = 'SET_PLANNED_DOWNTIME'

export const TOGGLE_BROADCASTER_INTRO_TUTORIAL = 'TOGGLE_BROADCASTER_INTRO_TUTORIAL'

export const INCREMENT_LIST_RENDER_COUNT = 'INCREMENT_LIST_RENDER_COUNT'
